import React from 'react';
import SpaceCard from './SpaceCard';

interface Space {
    id: string;
    ownerName: string;
    region: string;
    location: string;
    price: number;
    status: string;
    mainImageUrl: string;
    createdAt: string;
    updatedAt: string;
    tags: string[];
    reservationCount: number;
    ownerCertified: boolean;
    isFavorite: boolean;
  }
  

interface Props {
  spaces: Space[];
  loading: boolean;
  onTouchStart?: (e: React.TouchEvent) => void;
  onTouchEnd?: (e: React.TouchEvent) => void;
  onFavoriteChange?: (spaceId: string, isFavorite: boolean) => void;
  isLoggedIn?: boolean;
}

const MainContent: React.FC<Props> = ({ spaces, loading, onTouchStart, onTouchEnd, onFavoriteChange, isLoggedIn = true }) => {
  return (
    <main
      className="grid grid-cols-1 lg:grid-cols-2 gap-6 flex-grow"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : spaces.length === 0 ? (
        <div className="text-center text-gray-500">등록된 공간이 없습니다.</div>
      ) : (
        spaces.map((space) => (
          <SpaceCard 
            key={space.id} 
            space={space} 
            onFavoriteChange={onFavoriteChange}
            isLoggedIn={isLoggedIn}
          />
        ))
      )}
    </main>
  );
};

export default MainContent;
